import axios from 'axios'
import {APIBPJS} from 'config/apiurl'
import qs from 'qs'

const defError = (
    code = 'WPC',
    message = 'Gagal saat mengambil data, silakan coba kembali!',
    withCode = true
  ) => ({
    status: 0,
    message: `${withCode ? '[' + code + ']' : ''}${message}`,
  }),
  dArgs = {
    type: 'kunjungan',
    reg: 'dbdok',
    a: 'dk13',
  }
export const qIndex = async args => {
  try {
    const {data} = await axios.post(
      APIBPJS + '/bpjs-jkn/get-kunjungan-pcare',
      qs.stringify({...args, ...dArgs})
    )

    return data
  } catch (e) {
    return defError('EPSS-CE-2')
  }
}
export const mDelete = async args => {
  try {
    const {data} = await axios.post(
      APIBPJS + '/bpjs-jkn/delete-kunjungan-pcare',
      qs.stringify({
        ...args,
        ...dArgs,
        sl: {
          ket: `Menghapus Data Kunjungan PCare${
            args?.noKunjungan
              ? ` dengan No. Kunjungan ${args?.noKunjungan}`
              : ''
          }`,
          url: 'pcare-data-entri-kunjungan',
        },
      })
    )

    return data
  } catch (e) {
    return defError('EPSS-CE-2')
  }
}

export const mBatalKunjungan = async args => {
  try {
    const {data} = await axios.post(
      APIBPJS + '/bpjs-jkn/delete-pcare-pemeriksaan',
      qs.stringify({
        ...args,
        ...dArgs,
        sl: {
          ket: `Menghapus Data Kunjungan PCare${
            args?.noKunjungan
              ? ` dengan No. Kunjungan ${args?.noKunjungan}`
              : ''
          }`,
          url: 'pcare-data-entri-kunjungan',
        },
      })
    )

    return data
  } catch (e) {
    return defError('EPSS-CE-2')
  }
}
